import { createI18n } from 'vue-i18n';
import type { Ref } from 'vue';

import zhCN from '../../locales/zh-CN';
import enUS from '../../locales/en-US';
import deDE from '../../locales/de-DE';
import frFR from '../../locales/fr-FR';
import nlNL from '../../locales/nl-NL';
import itIt from '../../locales/it-IT';
import plPL from '../../locales/pl-PL';
import ptPT from '../../locales/pt-BR';
import viVN from '../../locales/vi-VN';
import esES from '../../locales/es-ES';
import trTR from '../../locales/tr-TR';
import csCZ from '../../locales/cs-CZ';
import huHU from '../../locales/hu-HU';
import ruRU from '../../locales/ru-RU';
import zhTW from '../../locales/zh-TW';
import svSE from '../../locales/sv-SE';
import skSK from '../../locales/sk-SK';
import thTH from '../../locales/th-TH';
import ukUA from '../../locales/uk-UA';
import etEE from '../../locales/et-EE';
import arSA from '../../locales/ar-SA';
import bgBG from '../../locales/bg-BG';
import daDK from '../../locales/da-DK';
import fiFI from '../../locales/fi-FI';
import hrHR from '../../locales/hr-HR';
import lvLV from '../../locales/lv-LV';
import ltLT from '../../locales/lt-LT';
import roRO from '../../locales/ro-RO';
import nbNO from '../../locales/nb-NO';
import ptBX from '../../locales/pt-BX';
import slSI from '../../locales/sl-SI';
import elGR from '../../locales/el-GR';
import kkKZ from '../../locales/kk-KZ';

import { Locales } from '~/composables/i18n';
import { setDayjsLocale } from '~/composables/useDayjs';
import { commonRequests } from '~/requests/common/common.request';
import { resHandler } from '~/utils/http/handler';
import { useCommonStore } from '~/stores/common';

export const useStorageLocale = createGlobalState(() => {
    const defaultLocale = useStorage('locale', ref<Locales>(Locales.enUS), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    }) as Ref<Locales>;

    return {
        defaultLocale,
    };
});

export const i18n = createI18n({
    legacy: false,
    messages: {
        [Locales.zhCN]: zhCN,
        [Locales.enUS]: enUS,
        [Locales.deDE]: deDE,
        [Locales.frFR]: frFR,
        [Locales.nlNL]: nlNL,
        [Locales.itIT]: itIt,
        [Locales.viVN]: viVN,
        [Locales.esES]: esES,
        [Locales.plPL]: plPL,
        [Locales.ptPT]: ptPT,
        [Locales.trTR]: trTR,
        [Locales.csCZ]: csCZ,
        [Locales.huHU]: huHU,
        [Locales.ruRU]: ruRU,
        [Locales.zhTW]: zhTW,
        [Locales.svSE]: svSE,
        [Locales.skSK]: skSK,
        [Locales.thTH]: thTH,
        [Locales.ukUA]: ukUA,
        [Locales.etEE]: etEE,
        [Locales.arSA]: arSA,
        [Locales.bgBG]: bgBG,
        [Locales.daDK]: daDK,
        [Locales.fiFI]: fiFI,
        [Locales.hrHR]: hrHR,
        [Locales.lvLV]: lvLV,
        [Locales.ltLT]: ltLT,
        [Locales.roRO]: roRO,
        [Locales.nbNO]: nbNO,
        [Locales.ptBR]: ptBX,
        [Locales.slSI]: slSI,
        [Locales.elGR]: elGR,
        [Locales.kkKZ]: kkKZ,
    },
    allowComposition: true,
});

export const { global: i18nGlobal } = i18n;

const i18nScope = effectScope();

export const initI18nScope = () => {
    i18nScope.run(() => {
        const { defaultLocale: locale } = useStorageLocale();
        const store = useCommonStore();

        i18nGlobal.locale.value = locale.value as any;

        setDayjsLocale(locale.value);

        watch(i18nGlobal.locale, async (val) => {
            store.locale = val;
            setDayjsLocale(val);
            if (store.authToken) {
                const res = await commonRequests.switchLang();
                await resHandler(res);
                await store.reFetchRoutes(null, null);
            }
        });
    });
};
